import { InputNumber, Select } from 'antd';
import { RootStore } from '../../../stores/RootStore';

const BOOL_OPTIONS = [{ id: 1, name: 'Yes' }, { id: 0, name: 'No' }];

export const Actions = {
    buy_enabled: {
        name: 'Buy Enabled',
        description: '',
        inputs: []
    },
    sell_enabled: {
        name: 'Sell Enabled',
        description: '',
        inputs: []
    },
    adca_enabled: {
        name: 'ADCA Enabled',
        description: '',
        inputs: []
    },
    art_enabled: {
        name: 'ART Enabled',
        description: '',
        inputs: []
    },
    buy_disabled: {
        name: 'Buy Disabled',
        description: '',
        inputs: []
    },
    sell_disabled: {
        name: 'Sell Disabled',
        description: '',
        inputs: []
    },
    adca_disabled: {
        name: 'ADCA Disabled',
        description: '',
        inputs: []
    },
    art_disabled: {
        name: 'ART Disabled',
        description: '',
        inputs: []
    },
    panic_sell: {
        name: 'Panic Sell',
        description: '',
        inputs: [
            {
                name: 'to_stable',
                label: 'To Stable',
                default: '0',
                component: Select,
                options: () => BOOL_OPTIONS
            }
        ]
    },
    buy_bnb: {
        name: 'Replenish BNB',
        description: '',
        inputs: [
            {
                name: 'min_threshold',
                label: 'Minimum BNB',
                default: 1,
                component: InputNumber
            },
            {
                name: 'rebuy_amount',
                label: 'Rebuy Amount',
                default: 1,
                component: InputNumber
            },
            {
                name: 'use_total_allocation',
                label: 'Use Position Allocation',
                default: '0',
                component: Select,
                options: () => BOOL_OPTIONS
            }
        ]
    },
    rebuy_base: {
        name: 'Rebuy Base Currency',
        description: '',
        inputs: []
    },
    switch_strategy: {
        name: 'Switch Strategy',
        description: '',
        inputs: [
            {
                name: 'strategy_id',
                label: 'Strategy',
                default: '',
                component: Select,
                options: () => RootStore.strategyStore.buySell
            }
        ]
    },
    position_exposure_switch_strategy: {
        name: 'Position Exposure: Switch Strategy',
        description: '',
        inputs: [
            {
                name: 'min_exposure',
                label: 'Min Exposure (Mins)',
                default: 60,
                component: InputNumber
            },
            {
                name: 'strategy_id',
                label: 'Strategy',
                default: '',
                component: Select,
                options: () => RootStore.strategyStore.buySell
            }
        ]
    },
    position_exposure_market_sell: {
        name: 'Position Exposure: Market Sell',
        description: '',
        inputs: [
            {
                name: 'min_exposure',
                label: 'Min Exposure (Mins)',
                default: 60,
                component: InputNumber
            },
            {
                name: 'min_result',
                label: 'Min Result %',
                default: 0.15,
                component: InputNumber
            },
            {
                name: 'max_result',
                label: 'Max Result %',
                default: 100,
                component: InputNumber
            }
        ]
    }
};



// WEBPACK FOOTER //
// ./src/Account/Bot/TriggerView/actions.js